import { Download, Redo2, Rocket, Undo2 } from "lucide-react";

import { Button } from "../ui/button";
import { EditorViewMode } from "../../stores/UIStore";
import { FC } from "react";
import { PyodideState } from "../../services/PyodideService";
import ViewModeToggle from "./ViewModeToggle";
import { observer } from "mobx-react-lite";

interface SecondaryTopBarProps {
    onSaveProject?: () => void;
    onDeploy?: () => void;
    isDeploying?: boolean;
    projectId?: string | null;
    isPyodideLoaded?: boolean;
    pyodideState?: PyodideState;
    pyodideLoadingStatus?: string;
    viewMode: EditorViewMode;
    onViewModeChange: (mode: EditorViewMode) => void;
    onUndo?: () => void;
    onRedo?: () => void;
    canUndo?: boolean;
    canRedo?: boolean;
}

const SecondaryTopBar: FC<SecondaryTopBarProps> = observer(({
    onSaveProject,
    onDeploy,
    isDeploying = false,
    projectId,
    isPyodideLoaded = false,
    viewMode,
    onViewModeChange,
    onUndo,
    onRedo,
    canUndo = false,
    canRedo = false
}) => {
    return (
        <div className="flex items-center justify-between h-8 px-4 shrink-0 border-b border-gray-200">
            <div className="flex items-center gap-4">
                {projectId && (
                    <>
                        <ViewModeToggle
                            viewMode={viewMode}
                            onViewModeChange={onViewModeChange}
                        />
                        <div className="flex items-center gap-1">
                            <Button
                                variant="outline"
                                size="sm"
                                className="h-6 px-2 text-xs font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-gray-200"
                                onClick={onUndo}
                                disabled={!onUndo || !canUndo}
                            >
                                <Undo2 className="h-3 w-3" />
                            </Button>
                            <Button
                                variant="outline"
                                size="sm"
                                className="h-6 px-2 text-xs font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-gray-200"
                                onClick={onRedo}
                                disabled={!onRedo || !canRedo}
                            >
                                <Redo2 className="h-3 w-3" />
                            </Button>
                        </div>
                    </>
                )}
            </div>
            <div className="flex items-center gap-2">
                {projectId && isPyodideLoaded && (
                    <>
                        <Button
                            variant="outline"
                            size="sm"
                            className="h-6 px-2 text-xs font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-gray-200"
                            onClick={onSaveProject}
                        >
                            <Download className="h-3 w-3 mr-1" />
                            Download
                        </Button>
                        <Button
                            variant="outline"
                            size="sm"
                            className="h-6 px-2 text-xs font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-gray-200"
                            onClick={onDeploy}
                            disabled={isDeploying}
                        >
                            <Rocket className="h-3 w-3 mr-1" />
                            {isDeploying ? "Publishing..." : "Publish"}
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
});

export default SecondaryTopBar; 